"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disable = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _actions = require("../../../actions");
var initialState = {
  loading: false
};
var disable = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(_actions.disableTotpAction.pending, function (state) {
    state.loading = true;
  });
  builder.addCase(_actions.disableTotpAction.rejected, function (state) {
    state.loading = false;
  });
  builder.addCase(_actions.disableTotpAction.fulfilled, function (state) {
    state.loading = false;
    state.done = true;
  });
  builder.addCase(_actions.resetDisableTotpAction, function () {
    return initialState;
  });
});
exports.disable = disable;